
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class FqzsTable extends Vue {
    //飞禽走兽
    table = {
        data: [],
        column: [
            {
                key: 'black',
                title: '下注飞禽',
                align: 'center',
                render: (h, params) => {
                    let birds: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.birds) {
                        birds = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.birds.bet)
                    }
                    return h('span', birds)
                }
            },
            {
                key: 'black',
                title: '下注走兽',
                align: 'center',
                render: (h, params) => {
                    let beast: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.beast) {
                        beast = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.beast.bet)
                    }
                    return h('span', beast)
                }
            },
            {
                key: 'black',
                title: '下注金鲨/银鲨',
                align: 'center',
                width: 85,
                render: (h, params) => {
                    let shark: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.shark) {
                        shark = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.shark.bet)
                    }
                    return h('span', shark)
                }
            },
            {
                key: 'black',
                title: '下注鸵鸟',
                align: 'center',
                render: (h, params) => {
                    let ostrich: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.ostrich) {
                        ostrich = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.ostrich.bet)
                    }
                    return h('span', ostrich)
                }
            },
            {
                key: 'black',
                title: '下注老鹰',
                align: 'center',
                render: (h, params) => {
                    let eagle: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.eagle) {
                        eagle = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.eagle.bet)
                    }
                    return h('span', eagle)
                }
            },
            {
                key: 'black',
                title: '下注猫头鹰',
                align: 'center',
                width: 85,
                render: (h, params) => {
                    let owl: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.owl) {
                        owl = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.owl.bet)
                    }
                    return h('span', owl)
                }
            },
            {
                key: 'black',
                title: '下注鸡',
                align: 'center',
                render: (h, params) => {
                    let chicken: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.chicken) {
                        chicken = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.chicken.bet)
                    }
                    return h('span', chicken)
                }
            },
            {
                key: 'black',
                title: '下注熊猫',
                align: 'center',
                render: (h, params) => {
                    let panda: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.panda) {
                        panda = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.panda.bet)
                    }
                    return h('span', panda)
                }
            },
            {
                key: 'black',
                title: '下注猴子',
                align: 'center',
                render: (h, params) => {
                    let monkey: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.monkey) {
                        monkey = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.monkey.bet)
                    }
                    return h('span', monkey)
                }
            },
            {
                key: 'black',
                title: '下注兔子',
                align: 'center',
                render: (h, params) => {
                    let rabbit: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.rabbit) {
                        rabbit = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.rabbit.bet)
                    }
                    return h('span', rabbit)
                }
            },
            {
                key: 'black',
                title: '下注狮子',
                align: 'center',
                render: (h, params) => {
                    let lion: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.lion) {
                        lion = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.lion.bet)
                    }
                    return h('span', lion)
                }
            },
            {
                key: 'black',
                title: '开奖结果（类别）',
                align: 'center',
                width: 105,
                render: (h, params) => {
                    let str: any = '/'
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        let hitArr = JSON.parse(params.row.opt_detail).award_content.hit
                        let arr = Object.keys(hitArr)
                        let obj = {
                            beast: '走兽',
                            birds: '飞禽'
                        }
                        arr.map((item) => {
                            if (obj[item]) {
                                str = obj[item] + '（' + 'x' + hitArr[item] + '）'
                            }
                        })
                    }
                    return h('span', str)
                }
            },
            {
                key: 'black',
                title: '开奖结果（动物）',
                align: 'center',
                width: 105,
                render: (h, params) => {
                    let str = '/'
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        let hitArr = JSON.parse(params.row.opt_detail).award_content.hit
                        let arr = Object.keys(hitArr)
                        let nameArr = ['shark', 'gold_shark', 'silver_shark', 'monkey', 'eagle', 'chicken', 'lion', 'panda', 'owl', 'ostrich', 'rabbit']
                        let s: any
                        let num: any = null
                        arr.map((item) => {
                            if (nameArr.includes(item)) {
                                s = item
                                num = hitArr[item]
                            }
                        })
                        switch (s) {
                            case 'shark':
                                str = '金鲨/银鲨'
                                break
                            case 'gold_shark':
                                str = '金鲨'
                                break
                            case 'silver_shark':
                                str = '银鲨'
                                break
                            case 'monkey':
                                str = '猴子'
                                break
                            case 'eagle':
                                str = '老鹰'
                                break
                            case 'chicken':
                                str = '鸡'
                                break
                            case 'lion':
                                str = '狮子'
                                break
                            case 'panda':
                                str = '熊猫'
                                break
                            case 'owl':
                                str = '猫头鹰'
                                break
                            case 'ostrich':
                                str = '鸵鸟'
                                break
                            case 'rabbit':
                                str = '兔子'
                                break
                            default:
                                break
                        }
                        str = str + '（' + 'x' + num + '）'
                    }
                    return h('span', str)
                }
            },
            {
                key: 'black',
                title: '总投注',
                align: 'center',
                render: (h, params) => {
                    let str = 0
                    let arr = JSON.parse(params.row.opt_detail).hits.hits
                    for (const key in arr) {
                        str += (this as any).getMoney(arr[key].bet, 1)
                    }
                    return h('span', str.toFixed(2))
                }
            },
            {
                key: 'black',
                title: '总返奖',
                align: 'center',
                render: (h, params) => {
                    let str = (this as any).getMoney(params.row.chang_point)
                    let color = '#333'
                    if (str > 0) {
                        color = 'red'
                    } else if (str < 0) {
                        color = 'blue'
                    }
                    return h(
                        'span',
                        {
                            style: {
                                color: color
                            }
                        },
                        str
                    )
                }
            }
        ]
    }

    @Prop()
    listdata
}
